import { useState } from 'react';
import { EyeOutlined } from '@ant-design/icons';
import { AccessCaseNotice } from '@prisma/client';
import { Button } from 'antd';
import Table, { ColumnsType } from 'antd/es/table';

import { formatIsoDate } from '@app/utils-agnostic';

import { NoticeModal } from './notice-modal';
import { NoticeTypeRenderer } from './notice-type-renderer';

export type NoticeTableProps = {
  notices: AccessCaseNotice[];
};

export const NoticeTable = ({ notices }: NoticeTableProps) => {
  const [showNotice, setShowNotice] = useState<AccessCaseNotice | undefined>();

  const columns: ColumnsType<AccessCaseNotice> = [
    {
      title: 'Action',
      width: 200,
      render: (_, record) => {
        return (
          <Button size="small" icon={<EyeOutlined />} onClick={() => setShowNotice(record)}>
            View Notice
          </Button>
        );
      },
    },
    {
      title: 'Type',
      dataIndex: 'type',
      sorter: true,
      render: (name: string) => <NoticeTypeRenderer name={name} />,
    },
    {
      width: 250,
      title: 'Created On',
      dataIndex: 'createdOn',
      sorter: true,
      render: (date: string) => formatIsoDate(date),
    },
  ];

  return (
    <>
      <NoticeModal notice={showNotice} onClose={() => setShowNotice(undefined)} />
      <Table<AccessCaseNotice>
        rowKey={(record) => record.id}
        columns={columns}
        dataSource={notices}
        size="small"
        scroll={{
          y: 300,
        }}
      />
    </>
  );
};
